import React from 'react'
import '../../Styles/AdditionalPages/Courses.css'

export default function Courses() {
  return (
    <div className='courses'>
        <div className="coursescontainer">

          <div className="bacourse subcourses">
            <h1 className='courseshead'>B.A. - BACHELOR OF ARTS</h1>
            <div className="coursespara">The Bachelor of Arts (B.A.) program at our college offers students a comprehensive and dynamic education in the liberal arts. Through this program, students have the opportunity to explore a wide range of disciplines, including humanities, social sciences, fine arts, and more. The B.A. program aims to develop critical thinking, communication skills, and a broad understanding of the world, preparing students for various career paths and further academic pursuits. With a strong emphasis on interdisciplinary learning, students can tailor their B.A. degree to their individual interests and goals, fostering creativity, adaptability, and a well-rounded education. Our dedicated faculty members provide mentorship and guidance to help students excel academically and grow personally, creating a vibrant learning environment. Graduates of our B.A. program emerge as versatile individuals equipped with valuable skills, ready to make a positive impact in their chosen fields and contribute to society at large.</div>
            <table>
              <thead>
              <tr>
                <th className='semesterblock'>SEMESTER</th>
                <th>SUBJECTS</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className='semesterblock'>Semester 1</td>
                <td>English Literature, History, Political Science</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 2</td>
                <td>Sociology, Psychology, Economics</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 3</td>
                <td>Philosophy, Geography, Elective Language (e.g., French, Spanish)</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 4</td>
                <td>Fine Arts, Anthropology, Literature in Regional Language</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 5</td>
                <td>Gender Studies, International Relations, Elective Course (e.g., Creative Writing)</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 6</td>
                <td>Cultural Studies, Comparative Literature, Elective Course (e.g., Film Studies)</td>
              </tr>
              </tbody>
            </table>
            <h2 className='coursesfee'>FEE STRUCTURE - 6000/YEAR</h2>
          </div>

          <div className="bedcourse subcourses">
            <h1 className='courseshead'>B.Ed. - BACHELOR OF EDUCATION</h1>
            <div className="coursespara">The Bachelor of Education (B.Ed) program at our college is designed for aspiring educators who are passionate about shaping the future through teaching. This program offers a comprehensive curriculum that combines theoretical knowledge with practical teaching experiences. Students gain a deep understanding of educational theories, instructional strategies, and classroom management techniques. Through engaging coursework and hands-on teaching practice, students develop the necessary skills to create inclusive and effective learning environments. Our experienced faculty members provide mentorship and guidance, ensuring that students receive a well-rounded education. The B.Ed program also includes opportunities for specialization in various subjects or grade levels, enabling students to tailor their studies to their specific interests and career goals. Upon completion of the program, graduates are equipped with the knowledge, skills, and professionalism needed to become successful educators and make a positive impact on the lives of their students.</div>
            <table>
              <thead>
              <tr>
                <th className='semesterblock'>Semester</th>
                <th>Subjects</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className='semesterblock'>Semester 1</td>
                <td>Foundations of Education, Educational Psychology, Teaching Methods</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 2</td>
                <td>Classroom Management, Curriculum Development, Assessment and Evaluation</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 3</td>
                <td>Educational Technology, Special Education, Elective (e.g., Guidance and Counseling)</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 4</td>
                <td>Educational Research, Inclusive Education, Pedagogy of Social Sciences</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 5</td>
                <td>Pedagogy of English, Pedagogy of Mathematics, Internship</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 6</td>
                <td>Pedagogy of Science, Pedagogy of Social Studies, Action Research</td>
              </tr>
              </tbody>
            </table>
            <h2 className='coursesfee'>FEE STRUCTURE - 6000/YEAR</h2>
          </div>

          <div className="bcomcourse subcourses">
            <h1 className='courseshead'>B.COM. - BACHELOR OF COMMERCE</h1>
            <div className="coursespara">The Bachelor of Commerce (B.Com) program at our college equips students with a strong foundation in the field of commerce and business management. This comprehensive program offers a diverse range of courses encompassing subjects such as accounting, finance, marketing, economics, and business law. Through a combination of theoretical knowledge and practical applications, students gain a deep understanding of key business principles and practices. The B.Com program emphasizes the development of critical thinking, problem-solving, and analytical skills, enabling graduates to excel in the competitive business landscape. Our experienced faculty members bring their industry expertise into the classroom, providing students with valuable insights and real-world perspectives. Additionally, the program incorporates internships and practical training opportunities, allowing students to apply their knowledge in real business settings. Upon completion of the B.Com program, graduates are well-prepared for a variety of careers in fields such as finance, accounting, marketing, consulting, and entrepreneurship. They possess the necessary skills and knowledge to thrive in the rapidly evolving business world and contribute to the success of organizations.</div>
            <table>
              <thead>
              <tr>
                <th className='semesterblock'>Semester</th>
                <th>Subjects</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className='semesterblock'>Semester 1</td>
                <td>Financial Accounting, Business Communication, Microeconomics</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 2</td>
                <td>Cost Accounting, Business Law, Macroeconomics</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 3</td>
                <td>Financial Management, Marketing Management, Business Statistics</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 4</td>
                <td>Corporate Accounting, Business Ethics, Human Resource Management</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 5</td>
                <td>Taxation, Auditing, E-Commerce</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 6</td>
                <td>Banking and Insurance, Entrepreneurship, Strategic Management</td>
              </tr>
              </tbody>
            </table>
            <h2 className='coursesfee'>FEE STRUCTURE - 7000/YEAR</h2>
          </div>

          <div className="bsccourse subcourses">
            <h1 className='courseshead'>B.Sc. - BACHELOR OF SCIENCE</h1>
            <div className="coursespara">The Bachelor of Science (B.Sc) program at our college offers students a comprehensive and rigorous education in the field of sciences. This program is designed to foster scientific inquiry, critical thinking, and analytical skills. Students have the opportunity to explore a wide range of disciplines, including biology, chemistry, physics, mathematics, computer science, and more. The B.Sc curriculum combines theoretical knowledge with hands-on laboratory experiences and research projects, providing students with practical skills and a deep understanding of scientific principles. Our dedicated faculty members, who are experts in their respective fields, provide guidance and mentorship to students throughout their academic journey. The B.Sc program also emphasizes interdisciplinary approaches, allowing students to integrate knowledge from multiple scientific disciplines. Graduates of our B.Sc program are well-prepared for careers in various scientific fields, research institutions, academia, and further academic pursuits such as postgraduate studies. They emerge as skilled scientists ready to contribute to scientific advancements and tackle the complex challenges of the modern world.</div>
            <table>
              <thead>
              <tr>
                <th className='semesterblock'>Semester</th>
                <th>Subjects</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td className='semesterblock'>Semester 1</td>
                <td>Physics, Chemistry, Mathematics</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 2</td>
                <td>Biology, Environmental Science, Computer Science</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 3</td>
                <td>Organic Chemistry, Physical Chemistry, Statistics</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 4</td>
                <td>Botany, Zoology, Biochemistry</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 5</td>
                <td>Genetics, Ecology, Biotechnology</td>
              </tr>
              <tr>
                <td className='semesterblock'>Semester 6</td>
                <td>Microbiology, Environmental Studies, Research Project</td>
              </tr>
              </tbody>
            </table>
            <h2 className='coursesfee'>FEE STRUCTURE - 8500/YEAR</h2>
          </div>

          <div className="macourse subcourses">
            <h1 className='courseshead'>M.A. - MASTER OF ARTS</h1>
            <div className="coursespara">The MA program at Maharishi Dayanand College offers a stimulating academic journey for students passionate about the humanities and social sciences. Through rigorous coursework and engaging research, students delve deep into their chosen field of specialization, honing critical analysis skills and expanding their intellectual horizons. Our renowned faculty guide students through an array of thought-provoking courses, fostering a vibrant learning environment. Upon completion of the MA program, graduates are equipped with advanced knowledge, research proficiency, and the analytical tools necessary for successful careers in academia, research institutions, public administration, and the private sector. Discover new perspectives, challenge your thinking, and embark on a fulfilling academic journey with our MA program at Maharishi Dayanand College.</div>
            <table>
              <thead>
                <tr>
                  <th className="semesterblock">Semester</th>
                  <th>Subjects</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="semesterblock">Semester 1</td>
                  <td>Introduction to [Specialization], Research Methodology, [Elective Subject 1], [Elective Subject 2]</td>
                </tr>
                <tr>
                  <td className="semesterblock">Semester 2</td>
                  <td>Advanced Topics in [Specialization], Qualitative Research Methods, [Elective Subject 3], [Elective Subject 4]</td>
                </tr>
                <tr>
                  <td className="semesterblock">Semester 3</td>
                  <td>Seminar in [Specialization], Quantitative Research Methods, [Elective Subject 5], [Elective Subject 6]</td>
                </tr>
                <tr>
                  <td className="semesterblock">Semester 4</td>
                  <td>Thesis/Dissertation</td>
                </tr>
              </tbody>
            </table>
            <h2 className='coursesfee'>FEE STRUCTURE - 9000/YEAR</h2>
          </div>

          <div className="mcomcourse subcourses">
            <h1 className='courseshead'>M.Com. - MASTER OF COMMERCE</h1>
            <div className="coursespara">The MCom program at Maharishi Dayanand College is designed for individuals seeking a comprehensive understanding of commerce, finance, and business management. Through a blend of theoretical knowledge and practical applications, students gain insights into areas such as accounting, economics, marketing, and financial management. Our distinguished faculty guide students through industry-relevant coursework, case studies, and experiential learning opportunities, preparing them for leadership roles in corporate organizations, financial institutions, or entrepreneurial ventures. With a focus on critical thinking, strategic decision-making, and ethical business practices, our MCom program equips graduates with the necessary skills to thrive in the dynamic world of commerce. Join us at Maharishi Dayanand College and unlock your potential for success in the realm of commerce with our esteemed MCom program.</div>
            <table>
              <thead>
                <tr>
                  <th className="semesterblock">Semester</th>
                  <th>Subjects</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="semesterblock">Semester 1</td>
                  <td>Financial Accounting, Business Economics, Marketing Management, Managerial Communication, Organizational Behavior</td>
                </tr>
                <tr>
                  <td className="semesterblock">Semester 2</td>
                  <td>Cost Accounting, Business Statistics, Financial Management, Business Environment, Research Methodology</td>
                </tr>
                <tr>
                  <td className="semesterblock">Semester 3</td>
                  <td>Advanced Financial Accounting, Corporate Law, International Business, Entrepreneurship Development, Elective Subject 1</td>
                </tr>
                <tr>
                  <td className="semesterblock">Semester 4</td>
                  <td>Management Accounting, Strategic Management, Business Ethics, Elective Subject 2, Project Work</td>
                </tr>
              </tbody>
            </table>
            <h2 className='coursesfee'>FEE STRUCTURE - 9000/YEAR</h2>
          </div>

        </div>
    </div>
  )
}
